function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".list-checked-1{fill:none;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "list--checked");

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 8,
  width: 14,
  height: 2
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  points: "6 10.59 3.41 8 2 9.41 6 13.41 14 5.41 12.59 4 6 10.59"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 22,
  width: 14,
  height: 2
});

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  points: "6 24.59 3.41 22 2 23.41 6 27.41 14 19.41 12.59 18 6 24.59"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  id: "_Transparent_Rectangle_",
  "data-name": "<Transparent Rectangle>",
  className: "list-checked-1",
  width: 32,
  height: 32
});

var SvgListChecked = function SvgListChecked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgListChecked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list--checked.add843cb.svg";
export { ForwardRef as ReactComponent };